import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "labs-modal__title" }
const _hoisted_2 = { class: "labs-modal__content" }
const _hoisted_3 = { class: "labs-modal__bottom" }

import { useI18n } from 'vue-i18n';

import { ElButton } from 'element-plus';
import Modal from '@/components/Modal.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'MobileModal',
  props: {
    isOpen: { type: Boolean }
  },
  emits: ["close"],
  setup(__props: any, { emit: __emit }) {



const emits = __emit;

const { t } = useI18n();

const handleClose = () => {
  emits('close');
};

return (_ctx: any,_cache: any) => {
  return (_ctx.isOpen)
    ? (_openBlock(), _createBlock(Modal, {
        key: 0,
        class: "labs-modal",
        width: "330",
        hideCloseButton: "",
        onClose: handleClose
      }, {
        header: _withCtx(() => [
          _createElementVNode("h2", _hoisted_1, _toDisplayString(_unref(t)("labs.oops")), 1)
        ]),
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("p", null, _toDisplayString(_unref(t)("labs.mobileModalText")), 1),
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(ElButton), {
                type: "primary",
                class: "labs-modal__btn ui-btn --big-round",
                onClick: handleClose
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('labs.clearly')), 1)
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
}
}

})